import React from 'react';
import styles from '../../styles/home.module.css';
import stylesC from '../../styles/common.module.css';
import { IMAGEPATH } from '../../constants/imagePath';
import SectionTitle from '../common/SectionTitle';
import { KR } from '../../constants/localizations';

export default function HomeOverviewSection() {
    return (
        <div className={`${styles.overview} ${stylesC.maxWidth}`}>
            <SectionTitle title={KR.label_home_overview} titleEng={KR.label_home_overview_eng} />
            <div className={styles.contentWrap}>
                <div className={styles.content}>
                    <h3>
                        <span>
                            {KR.label_home_autonomous_lab}
                        </span>
                        {KR.label_home_autonomous_lab_eng}
                    </h3>
                    <p>
                        AR247은 <span>첨단 자율주행 로봇 연구개발</span>을 통해 <br />
                        다양한 분야의 라스트 마일 문제를 해결하는 연구소 입니다.
                    </p>
                    <p>
                        AR247 is a research institute addressing last-mile challenges across <br />
                        various fields through advanced autonomous robotics R&D.
                    </p>
                    <div className={styles.badge}>
                        <div>
                            {KR.label_home_slam}
                        </div>
                        <div>
                            {KR.label_home_ai}
                        </div>
                        <div>
                            {KR.label_home_motion}
                        </div>
                    </div>
                </div>
                <div className={styles.cardW}>
                    <div>
                        <img src={IMAGEPATH.robots1} srcSet={IMAGEPATH.robots1Webp} alt="ar247_robots" loading="lazy" />
                        <span>{KR.label_home_delivery}</span>
                    </div>
                    <div>
                        <img src={IMAGEPATH.robots2} srcSet={IMAGEPATH.robots2Webp} alt="ar247_robots" loading="lazy" />
                        <span>{KR.label_home_logistics}</span>
                    </div>
                    <div>
                        <img src={IMAGEPATH.solution} srcSet={IMAGEPATH.solutionWebp} alt="ar247_solution" loading="lazy" />
                        <span>{KR.label_home_solution}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
